module.exports = __webpack_public_path__ + "img/home-business-card.7ac6c267.jpg";